import helper from '../../../helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('portaliCamere');
export const actions = helper.createActions('portaliCamere', actionTypes);